import React, {useEffect, useImperativeHandle, useRef, useState} from "react";
import "./DetailTabInfo.scss";
import type {TabsProps} from "antd";
import {Button, Tabs} from "antd";
import ExamTab from "./components/ExamTab/ExamTab";
import SupplyList from "./components/SupplyList/SupplyList";
import {SpecifyTab} from "./components/SpecifyTab/SpecifyTab";
import AssignList from "./components/AssignList/AssignList";
import ConcludePrecription from "./components/ConcludePrecription/ConcludePrecription";

import {tabKeys} from "types/enums";
import {setActiveExamTab, setRef} from "redux/reducer/examination";
import {useDispatch} from "react-redux";
import {useAppDispatch, useAppSelector} from "redux/hooks";
import {isValuable} from "helper/common";

const DetailTabInfo = React.forwardRef((props: any, ref) => {
  const dispatch = useAppDispatch();
  const childRef = useRef<any>();
  const specifyRef = useRef<any>();
  const conPreRef = useRef<any>();
  const itemsInit: TabsProps["items"] = [
    {
      key: tabKeys.EXAMINATION_INFO_DETAIL.EXAM,
      label: `Khám bệnh`,
      children: <ExamTab ref={childRef} />,
    },
    {
      key: tabKeys.EXAMINATION_INFO_DETAIL.ASSIGN,
      label: `DS chỉ định`,
      children: <AssignList />,
    },
    {
      key: tabKeys.EXAMINATION_INFO_DETAIL.ASSIGN_BILL,
      label: `Phiếu chỉ định`,
      children: <SpecifyTab ref={specifyRef} bacSyKham={props.bacSyKham} />,
    },
    {
      key: tabKeys.EXAMINATION_INFO_DETAIL.CONCLUDE_PRESCRIPT,
      label: `Kết luận và đơn thuốc`,
      children: <ConcludePrecription ref={conPreRef} />,
    },
  ];

  const [items, setItems] = useState(itemsInit);
  const activeExamTab = useAppSelector(
    state => state.examination.activeExamTab
  );
  const activeTab = useAppSelector(state => state.common.activeTab);
  useImperativeHandle(ref, () => ({
    handleSave: handleSave,
  }));
  const handleSave = async () => {
    await specifyRef.current?.handleSave();
    await conPreRef.current?.handleSave();
  };

  useEffect(() => {
    if (activeTab == tabKeys.EXAMINATION.INFOR_DETAIL) {
      setItems(itemsInit);
      dispatch(setActiveExamTab(tabKeys.EXAMINATION_INFO_DETAIL.EXAM));
    }
  }, [activeTab]);
  useEffect(() => {
    if (isValuable(childRef.current)) {
      dispatch(setRef(childRef.current));
    }
  }, [childRef]);

  return (
    <div className="detail-tab-info-container">
      <div className="container">
        <Tabs
          items={items}
          activeKey={activeExamTab}
          onChange={key => {
            dispatch(setActiveExamTab(key));
          }}
          defaultActiveKey={tabKeys.EXAMINATION_INFO_DETAIL.EXAM}
        />
      </div>
    </div>
  );
});

export default DetailTabInfo;
